import type { UserCouponWithTemplate } from "../schema"

export function isCouponActive(coupon: UserCouponWithTemplate): boolean {
	return coupon.status === "unused"
}

export function isCouponNotStarted(coupon: UserCouponWithTemplate): boolean {
	return !!(
		coupon.couponTemplate?.startTime &&
		new Date(coupon.couponTemplate.startTime) > new Date()
	)
}

export function isCouponExpired(coupon: UserCouponWithTemplate): boolean {
	return ["expired", "used", "voided"].includes(coupon.status)
}

export function isCouponDisabled(coupon: UserCouponWithTemplate): boolean {
	return isCouponExpired(coupon) || isCouponNotStarted(coupon)
}

export function isCouponApplicableForPlatform(
	coupon: UserCouponWithTemplate,
	platform: string,
): boolean {
	return coupon.platformChannels?.includes(platform) ?? false
}

export function isCouponApplicableForWeb(
	coupon: UserCouponWithTemplate,
): boolean {
	return isCouponApplicableForPlatform(coupon, "web")
}

export function isCouponApplicableForStore(
	coupon: UserCouponWithTemplate,
): boolean {
	return isCouponApplicableForPlatform(coupon, "store")
}

export function isCouponAppOnly(coupon: UserCouponWithTemplate): boolean {
	return (
		coupon.platformChannels?.length === 1 &&
		coupon.platformChannels.includes("app")
	)
}

export function canUserUseCoupon(
	coupon: UserCouponWithTemplate,
	platform: string,
): boolean {
	return (
		isCouponActive(coupon) &&
		!isCouponNotStarted(coupon) &&
		isCouponApplicableForPlatform(coupon, platform)
	)
}
